import { useCallback, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Overlay } from './Overlay';

interface DialogProps {
  $scrollable: boolean;
}

const Dialog = styled.dialog<DialogProps>(
  ({ theme, $scrollable }) => css`
    width: calc(100% - 1rem);
    max-width: 500px;
    max-height: 80dvh;
    max-height: 80vh;
    border-radius: 0.5rem;
    box-shadow: 1px 2px 25px 1px #090909;
    background: ${theme.paper.modal};
    color: ${theme.text.default};
    border: none;
    position: absolute;
    top: 50px;
    display: flex;
    flex-direction: column;
    overflow: ${$scrollable ? 'hidden' : 'visible'};
  `
);

interface ModalProps {
  onClose(): void;
  isOpen: boolean;
  children: React.ReactNode;
  scrollable?: boolean;
}

export function Modal({
  onClose,
  isOpen,
  children,
  scrollable = false,
}: ModalProps): React.ReactElement | null {
  const disableScroll = useCallback(() => {
    if (!isOpen) return;

    const body = document.querySelector('body');

    if (!body) return;

    body.style.overflow = 'hidden';
  }, [isOpen]);

  function cleanup() {
    const body = document.querySelector('body');
    if (!body) return;

    body.style.overflow = 'auto';
  }

  useEffect(() => {
    if (!isOpen) return;

    disableScroll();

    return cleanup;
  }, [isOpen, disableScroll]);

  if (!isOpen) return null;

  return (
    <Overlay onClose={onClose}>
      <Dialog $scrollable={scrollable} open>
        {children}
      </Dialog>
    </Overlay>
  );
}
